module.exports = __webpack_public_path__ + "img/committed-to-diversity.aad3bb97.jpg";